'use client'

import { USE } from '@spot'
import Script from 'next/script'

const ChatJovin = () => {
  if (USE.jovin === false) {
    return null
  }
  return (
    // eslint-disable-next-line @next/next/no-before-interactive-script-outside-document
    <Script
      id="script-jovin-2"
      src="https://backend.jovin.ai/jovin-widget/loader.js"
      data-project-id={process.env.NEXT_PUBLIC_JOVIN_PROJECT_ID}
      data-locale="de"
      strategy="beforeInteractive"
    />
  )
}

export default ChatJovin
